import { render, staticRenderFns } from "./EventsCreateModal.vue?vue&type=template&id=ce2bdedc&"
import script from "./EventsCreateModal.vue?vue&type=script&lang=js&"
export * from "./EventsCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports